import { Path } from "react-native-svg";

import { type IconProps, LineIcon } from "./LineIcon";

export function PlusIcon(props: IconProps) {
  return (
    <LineIcon {...props}>
      <Path d="M12 5v14M5 12h14" />
    </LineIcon>
  );
}
